import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import DashboardLayout from './components/DashboardLayout';

function WithDashboardLayout({ children }: { children: React.ReactNode }) {
    return <DashboardLayout>{children}</DashboardLayout>;
}

export function createDashboardInertiaApp(
    options: Omit<Parameters<typeof createInertiaApp>[0], 'resolve'>,
) {
    return createInertiaApp({
        ...options,
        resolve: async (name) => {
            const pages = import.meta.glob(['./Pages/**/*.tsx', '!./Pages/**/components/**/*.tsx']);
            const page = await resolvePageComponent(`./Pages/${name}.tsx`, pages);
            const mod = page as { default: { layout?: unknown } };

            if (!mod.default.layout) {
                mod.default.layout = [WithDashboardLayout];
            }

            return page;
        },
    });
}
